import { Label, MutedText, ProductDetail, styled, Tabs } from '@tools/wr-catalog-base'

export const StyledProductDetail = styled.div`
  .product-detail-header {
    text-align: left;
    font-family: 'CenturyGothic';

    a {
      color: #212529;
      font-size: 1.25rem;
    }
  }

  .product-detail-price {
    font-family: OpenSans, sans-serif;
    font-size: 16px;
    color: #666;
    margin-top: 5px;
    display: block;
  }

  .product-details-add-to-order button {
    border-radius: 5px;
  }

  .product-detail-price p {
    color: #333;
    font-weight: 800;
  }

  .product-details-description-card {
    font-size: 13px;
    font-family: OpenSans, sans-serif;
  }

  .documents-table path {
    fill: #0696d7;
  }

  .dropdown-list li {
    list-style-type: none;
    margin: 0;
  }

  .product-details-cart input:not(.react-date-picker__inputGroup__input),
  .product-details-cart .react-date-picker > div {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom-style: solid;
    padding-left: 0;
    outline: none;
  }

  .product-details-cart button {
    border-radius: 5px;
  }

  .product-description {
    font-size: 13px;
    position: static !important;
  }

  ul li {
    list-style-type: disc;
    display: list-item;
    margin: 0 18px;
  }

  ol li {
    list-style-type: decimal;
  }

  ol {
    margin: 0 13px;
  }

  ${Tabs.TabLink} a {
    font-size: 14px;

    &:hover {
      color: #5bb745;
    }
  }

  ${Tabs.TabLink}.active a {
    color: #5bb745;
  }

  [class*='product-row__RowWrapper-'] {
    font-size: 13px;
  }

  ${ProductDetail.Feedback.Container} .wr__card-container {
    padding: 0;
  }

  ${Label}, ${Label} span {
    font-weight: bold;
  }

  ${MutedText} {
    font-style: italic;
    color: black;
  }
`
